import { useEffect } from 'react';
import { usePrevious } from './usePrevious';

export function useDidPropChange<T>(val: T, callback: () => any): void {
  const prev = usePrevious(val);
  useEffect(() => {
    if (prev !== val) {
      callback();
    }
  }, [prev, val, callback]);
}
